import React, { FC } from "react";
// import { Link } from "react-router-dom";
import { useForm } from "react-hook-form";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import "./login.css";
import { setTokens } from "../../Utils/AuthUtils";
import { baseAPIAuthUrl } from "../../Utils/BaseAPI";
import { useLoggedContext } from "../../Auth/AuthContext";
import PublicLayout from "../../Layouts/PublicLayout";
import { GetBasePath, GetGoBackFlag, SetGoBackFlag } from "../../Utils/BaseUtils";

const Login = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const navigate = useNavigate();
  const { auth, setAuth } = useLoggedContext();
  const basePath = GetBasePath();

  let location = useLocation();
  let params = new URLSearchParams(location.search);
  let previousRoute = params.get('previousRoute');

  const loginSuccess = (btn?: HTMLInputElement | HTMLElement) => {
    document.getElementById('loginErrorMessage')?.classList.remove('db');
    let successContainer = document.getElementById('loginSuccessMessage');
    successContainer?.classList.add('db');

    setTimeout(() => {
      setAuth(true);
      if (GetGoBackFlag()) {
        navigate(-2);
        SetGoBackFlag('false');
      } else {
        navigate('/');
      }
    }, 3000);
  };

  const loginFailure = (btn?: HTMLInputElement | HTMLElement) => {
    if (btn) {
      (btn as HTMLInputElement).disabled = false;
    }
    let errorContainer = document.getElementById('loginErrorMessage');
    errorContainer?.classList.add('db');
    setTimeout(function () {
      errorContainer?.classList.remove('db');
    }, 5000);
  };

  const login = (data: any) => {
    let params = {
      grant_type: 'password',
      username: data.email,
      password: data.password,
    };

    const submitBtn = document.getElementById('submit-btn');
    if (submitBtn) {
      (submitBtn as HTMLInputElement).disabled = true;
    }

    axios.post(baseAPIAuthUrl, new URLSearchParams(params), {
      headers: {
        "Content-Type": 'application/x-www-form-urlencoded',
      }
    }).then((response) => {
      //   IF EMAIL ALREADY EXISTS
      if (response) {
        setTokens(response);
        if (submitBtn) {
          loginSuccess(submitBtn);
        } else {
          loginSuccess();
        }

      }
    })
      .catch((error) => {
        if (submitBtn) {
          loginFailure(submitBtn);
        } else {
          loginFailure();
        }

      });
  };

  return (
      <PublicLayout>
      <div className="container vh">
        <div
          className="row d-flex justify-content-center align-items-center"
          style={{ height: "100vh" }}
        >
          <div className="card mb-3" style={{ maxWidth: "320px" }}>
            <div className="col-md-12">
              <div className="card-body">
                <h3 className="card-title text-center text-secondary mt-3">
                  Login Form
                </h3>
                <h3 className="login-error-message" id="loginErrorMessage">
                  Errore nel login. Riprova.
                </h3>
                <h3 className="login-success-message" id="loginSuccessMessage">
                  Sto effettuando il login...
                </h3>
                <form autoComplete="off" onSubmit={handleSubmit(login)}>
                  <div className="mb-3 mt-4">
                    <label className="form-label">Email</label>
                    <input
                      type="email"
                      className="form-control shadow-none"
                      id="exampleFormControlInput1"
                      {...register("email", { required: "Email is required!" })}
                    />
                    {errors.email && (
                      <p className="text-danger" style={{ fontSize: 14 }}>
                        {errors.email.message}
                      </p>
                    )}
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Password</label>
                    <input
                      type="password"
                      className="form-control shadow-none"
                      id="exampleFormControlInput2"
                      {...register("password", {
                        required: "Password is required!",
                      })}
                    />
                    {errors.password && (
                      <p className="text-danger" style={{ fontSize: 14 }}>
                        {errors.password.message}
                      </p>
                    )}
                  </div>
                  <div className="text-center mt-4 ">
                    <button
                      className="btn btn-outline-primary text-center shadow-none mb-3 submit-button"
                      type="submit"
                      id="submit-btn"
                    >
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </PublicLayout>
  );
};
export default Login;
